import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";

const _base = "simulateExamPaper/";

// 模拟练习 - 学位外语试卷列表
// 后端: GET /simulateExamPaper/dfl/page
// 返回: TableDataInfo<List<SimulateExamPaper>>
export const dflPaperPage = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "dfl/page", {
    data: _params,
    method: "GET",
  });
};

// 模拟练习 - 试卷详情
// 后端: GET /simulateExamPaper/examPaperDetail?examPaperId=
// 返回: AjaxResult<ExamPaperDetailVO>（含 studentExamId 字段：null=未做过，非空=已做过）
export const examPaperDetail = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "examPaperDetail", {
    data: _params,
    method: "GET",
  });
};

// 模拟练习 - 提交试卷
// 后端: POST /simulateExamPaper/submitExam  @RequestBody StudentSubmitExamVO{examPaperId, answerList:[{questionGroupId, questionId, studentAnswer}]}
export const submitExam = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "submitExam", {
    data: _params,
    method: "POST",
  });
};

// 模拟练习 - 查看试卷答题
// 后端: POST /simulateExamPaper/examResult  @RequestParam studentExamId
export const examResult = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "examResult", {
    data: Qs.stringify(_params),
    method: "POST",
  });
};

// 模拟练习 - 重做
// 后端: POST /simulateExamPaper/redo  @RequestParam studentExamId
export const redoExam = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "redo", {
    data: Qs.stringify(_params),
    method: "POST",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/simulateExamPaper.js